import { createStyles, makeStyles, Theme } from '@material-ui/core';
export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            padding: theme.spacing(0, 4, 4, 4),
        },
        header: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            marginLeft: theme.spacing(1),
        },
        heading: {
            color: '#2C2F31',
            fontWeight: 600,
            paddingLeft: '5px',
            marginBottom: '1px',
        },
        grow: {
            flexGrow: 1,
        },
    })
);